const GiftMessage = (props) => {
  const { order } = props;
  if (!order.giftMessage || order.giftMessage === '') {
    return null;
  }
  return (
    <div className="c7-order__customer-detail">
      <h4>Gift Message</h4>
      <p>{order.giftMessage}</p>
    </div>
  );
};

export default GiftMessage;
